module.exports = __webpack_public_path__ + "img/shot-h.972140ca.svg";